module.exports = __webpack_public_path__ + "static/media/fan_room_1.a6b73b23.mp4";